module.exports = __webpack_public_path__ + "static/media/square-caret-down-solid.96bbaef3.png";